import React from "react";
import classNames from "classnames";

import styles from "./Layout.css";

export default function Sidebar(_ref) {
  var children = _ref.children,
      className = _ref.className;

  return React.createElement(
    "div",
    { role: "complementary", className: classNames(styles.sidebar, className) },
    children
  );
}


// WEBPACK FOOTER //
// ./src/components/Library/Layout/Sidebar.js